var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "#556EE6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2355_67505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7368 39.9502H49.2287C38.3426 39.9502 29.4775 31.0852 29.4775 20.199V10.7368H39.9043V20.245C39.9043 25.3895 44.0842 29.5235 49.1828 29.5235H58.6909V39.9502H58.7368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3321 58.7369H32.1416V42.6144L26.8593 37.3321H10.7368V32.0957H29.0182L37.3321 40.4555V58.7369Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2355_67505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.5263,
    height: 50.5263,
    fill: "white",
    transform: "translate(10.7368 10.7368)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPicture);
export default __webpack_public_path__ + "static/media/logoPicture.7ce5f4119c13cf0827930000a1abc11e.svg";
export { ForwardRef as ReactComponent };